import React, { useEffect, useState } from "react";
import api from "../api";
import "./Table.css";

const fmt  = n => n != null ? "$" + Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "—";
const fmtN = n => n != null ? Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "—";
const fmtD = d => d ? new Date(d + "T12:00:00").toLocaleDateString() : "—";

const LEAD_SOURCE_LABELS = {
  self_generated:   "Self Generated",
  partner_referral: "Partner Referral",
  client_referral:  "Client Referral",
  company_referral: "Company Referral",
};

export default function Loans() {
  const [loans, setLoans]     = useState([]);
  const [search, setSearch]   = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/loans/").then(r => setLoans(r.data)).finally(() => setLoading(false));
  }, []);

  const filtered = loans.filter(l =>
    l.loan_number.toLowerCase().includes(search.toLowerCase()) ||
    (l.borrower_last_name || "").toLowerCase().includes(search.toLowerCase())
  );

  if (loading) return <div className="loading">Loading loans...</div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Loans</h1>
          <p className="page-subtitle">{loans.length} total loans</p>
        </div>
      </div>

      <div className="table-card">
        <div className="table-toolbar">
          <input
            className="search-input"
            placeholder="Search by loan number or borrower last name..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>

        <div style={{ overflowX: "auto" }}>
          <table className="data-table">
            <thead>
              <tr>
                <th>Loan Number</th>
                <th>Borrower Last Name</th>
                <th>Loan Amount</th>
                <th>Close Date</th>
                <th>Funding Date</th>
                <th>Loan Purpose</th>
                <th>Loan Type</th>
                <th>Lead Source</th>
                <th>Exception ($)</th>
                <th>Exception (bps)</th>
                <th>Commission ($)</th>
                <th>Commission (bps)</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 && (
                <tr><td colSpan={12} className="empty-row">No loans found</td></tr>
              )}
              {filtered.map(loan => (
                <tr key={loan.id}>
                  <td className="mono">{loan.loan_number}</td>
                  <td>{loan.borrower_last_name}</td>
                  <td className="mono">{fmt(loan.loan_amount)}</td>
                  <td>{fmtD(loan.close_date)}</td>
                  <td>{fmtD(loan.funding_date)}</td>
                  <td>{loan.loan_purpose || "—"}</td>
                  <td>{loan.loan_type}</td>
                  <td>{LEAD_SOURCE_LABELS[loan.lead_source] || loan.lead_source || "—"}</td>
                  <td className="mono">{loan.exception_amount_dollars != null ? fmt(loan.exception_amount_dollars) : "—"}</td>
                  <td className="mono">{loan.exception_amount_bps != null ? fmtN(loan.exception_amount_bps) : "—"}</td>
                  <td className="mono">{fmt(loan.commission_amount)}</td>
                  <td className="mono">{loan.commission_bps != null ? loan.commission_bps : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
